import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgUser = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#user_svg__a)">
      <path
        fill="#AEAEAE"
        d="M25.257 23.188c-1.666-2.88-4.233-4.945-7.228-5.924a7.875 7.875 0 1 0-8.057 0c-2.996.978-5.563 3.043-7.229 5.924a.876.876 0 1 0 1.515.875C6.318 20.5 9.961 18.375 14 18.375s7.682 2.126 9.742 5.688a.874.874 0 0 0 1.617-.203.88.88 0 0 0-.102-.672M7.875 10.5A6.125 6.125 0 1 1 14 16.625 6.13 6.13 0 0 1 7.875 10.5"
      />
    </g>
    <defs>
      <clipPath id="user_svg__a">
        <path fill="currentColor" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
